import axios from "axios";
import { ADD_USER_EDIT_USER, GET_ALL_USERS, CHANGE_USER_STATUS, GET_SINGLE_USER_DETAILS , GET_ALL_ROLES, GET_ALL_ACTIVE_SALES_PERSON} from "../config/urlConfig";
import { convertToFormData } from "../utils/commenController";

// <-------------------------USER------------------------------------>
// Function for handling add & edit user api
export async function handleAddEditUserApi(userData, token) {
  try {
    
    let formData = await convertToFormData(userData);
    let response = await axios.post(ADD_USER_EDIT_USER, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all user
export async function getAllUsersDetailsApi(token, roleId, page, itemsPerPage) {
  try {
    const params =  new URLSearchParams();

    if(roleId){
      params.append('roleId' , roleId)
    }
      params.append('page',page)
      params.append('limit', itemsPerPage)
    let response = await axios.get(`${GET_ALL_USERS}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for handling change user status  api
export async function handleChangeUserStatusApi(userId, token) {
  try { 
    let response = await axios.patch(`${CHANGE_USER_STATUS}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

export async function fetchSingleUserDetailsApi(token , userId){
  try{
    try {
  
      let response = await axios.get(`${GET_SINGLE_USER_DETAILS}/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }catch(error){
    console.log("err", error.message);
    
  }
}

// Get Roles
export async function getAllRoles(token){
  try {
  console.log("GET_ALL_ROLES", GET_ALL_ROLES);
  
    let response = await axios.get(GET_ALL_ROLES, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("response", response);
    
    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all active  customer
export async function getAllActiveSalesPersonApi(token) {
  try {
  
    let response = await axios.get(GET_ALL_ACTIVE_SALES_PERSON, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}